// Imports ---------------------------------------------------------------------
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from '@/plugins/router'
import appMode from '@/plugins/appMode'
import i18n from '@/locales/i18n'
import mitt from '@/plugins/mitt'
import fabric from '@/plugins/fabric'
// import auth from '@/plugins/auth'
import VueTippy from 'vue-tippy'

import { useAuthStore } from '@/stores/auth'
import { useAppStateStore } from '@/stores/appState'

import resizeDirective from '@/directives/v-resize';

import App from './App.vue'

import '@/assets/style/tailwind.css'
import '@/assets/style/main.scss'

// Inits -----------------------------------------------------------------------
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(appMode)
app.use(i18n)
app.use(mitt)
app.use(fabric)
// app.use(auth)
app.use(
  VueTippy,
  // optional
  {
    directive: 'tippy', // => v-tippy
    component: 'tippy', // => <tippy/>
  }
)

app.directive('resize', resizeDirective)

const { authInit } = useAuthStore()
await authInit()

const { setQueryParamState } = useAppStateStore()
setQueryParamState()

app.use(router)

// Mount -----------------------------------------------------------------------
app.mount('#app')
